// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3LYlD","footer":"ChangeClinic_footer__HuK4M"};